import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { formatDate } from "@/lib/plant";

export const canCancel = (user) => user?.role !== "admin" && user?.subscription?.status === "active" && user?.is_premium;

// Controlled "Are you sure?" dialog that stops PayPal auto-renewal; Pro remains until period end.
export function CancelSubscriptionDialog({ open, onOpenChange, onBusy }) {
  const { user, refreshUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const end = user?.subscription?.current_period_end;

  const cancel = async () => {
    setBusy(true); onBusy?.(true);
    try {
      await api.post("/billing/cancel");
      await refreshUser();
      toast.success(`Subscription cancelled — Pro stays on until ${formatDate(end)}`);
    } catch {
      toast.error("Could not cancel");
    } finally {
      setBusy(false); onBusy?.(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="cancel-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>
            Automatic renewal stops now and you won't be charged again. Pro stays on until {formatDate(end)}, then your account returns to Free.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-confirm-no">Keep Pro</AlertDialogCancel>
          <AlertDialogAction onClick={cancel} disabled={busy} className="bg-destructive hover:bg-destructive/90" data-testid="cancel-confirm-yes">Yes, cancel</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
